"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackingProps = exports.SocialLinkProps = exports.SearchEngineOptimisationProps = exports.QuoteToolSectionProps = exports.QuoteToolContextProps = exports.HeaderProps = exports.FooterSectionProps = exports.FooterProps = exports.BrandDefinitionProps = exports.AboutYouSectionProps = exports.AboutPetSectionProps = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _propTypes2 = require("@PetSureAustralia/petsure-react-ui-library/distLib/propTypes");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BrandDefinitionProps = exports.BrandDefinitionProps = _propTypes["default"].shape({
  key: _propTypes["default"].string,
  title: _propTypes["default"].string,
  homeUrl: _propTypes["default"].string,
  cssUrls: _propTypes["default"].arrayOf(_propTypes["default"].string)
});
var SearchEngineOptimisationProps = exports.SearchEngineOptimisationProps = _propTypes["default"].shape({
  title: _propTypes["default"].string,
  description: _propTypes["default"].string
});
var TrackingProps = exports.TrackingProps = _propTypes["default"].shape({
  provider: _propTypes["default"].string,
  key: _propTypes["default"].string,
  keyValue: _propTypes["default"].string
});
var SocialLinkProps = exports.SocialLinkProps = _propTypes["default"].shape({
  icon: _propTypes["default"].string,
  label: _propTypes["default"].string,
  url: _propTypes["default"].string,
  svg: _propTypes["default"].element
});
var FooterSectionProps = exports.FooterSectionProps = _propTypes["default"].shape({
  heading: _propTypes["default"].string,
  content: _propTypes["default"].element,
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    url: _propTypes["default"].string
  }))
});
var FooterProps = exports.FooterProps = {
  customContent: _propTypes["default"].element,
  customCssClass: _propTypes["default"].string,
  socialLinks: _propTypes["default"].arrayOf(SocialLinkProps),
  copyright: _propTypes["default"].element,
  disclosure: _propTypes["default"].element,
  footerSections: _propTypes["default"].arrayOf(FooterSectionProps)
};
var HeaderProps = exports.HeaderProps = {
  logoImageUrl: _propTypes["default"].string,
  logoHoverText: _propTypes["default"].string,
  logoRedirectUrl: _propTypes["default"].string,
  pageTitleText: _propTypes["default"].string,
  customContent: _propTypes["default"].element,
  customCssClass: _propTypes["default"].string,
  headerShouldPin: _propTypes["default"].bool,
  contactDetails: _propTypes["default"].element
};
var QuoteToolSectionProps = exports.QuoteToolSectionProps = {
  heading: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  accordionBehaviour: _propTypes["default"].bool
};
var AboutPetSectionProps = exports.AboutPetSectionProps = _propTypes["default"].shape(_objectSpread(_objectSpread({}, QuoteToolSectionProps), {}, {
  animalRadios: _propTypes["default"].shape({
    dog: _propTypes2.StyledRadioPropType,
    cat: _propTypes2.StyledRadioPropType
  })
}));
var AboutYouSectionProps = exports.AboutYouSectionProps = _propTypes["default"].shape(_objectSpread({}, QuoteToolSectionProps));
var QuoteToolContextProps = exports.QuoteToolContextProps = _propTypes["default"].shape({
  brand: BrandDefinitionProps,
  seo: SearchEngineOptimisationProps,
  tracking: _propTypes["default"].arrayOf(TrackingProps),
  layout: {
    bodyCssClass: _propTypes["default"].string,
    header: HeaderProps,
    main: _propTypes["default"].shape({
      heading: _propTypes["default"].shape({
        headingText: _propTypes["default"].string,
        customCssClass: _propTypes["default"].string,
        mandatoryText: _propTypes["default"].string
      }),
      stepsBanner: _propTypes2.StepsBannerPropType,
      sections: {
        'aboutPet': AboutPetSectionProps,
        'aboutYou': AboutYouSectionProps
      },
      customContent: _propTypes["default"].element,
      customCssClass: _propTypes["default"].string,
      actionButtons: _propTypes["default"].shape({
        cancelLabel: _propTypes["default"].string,
        submitLabel: _propTypes["default"].string
      })
    }),
    footer: FooterProps,
    aside: _propTypes["default"].shape({
      campaigns: _propTypes["default"].arrayOf(_propTypes["default"].element)
    })
  }
});